import React from 'react';
import { FiImage } from 'react-icons/fi';

const VideoBackground = () => {
  const [imageError, setImageError] = React.useState(false);

  return (
    <div className="fixed inset-0 w-full h-full overflow-hidden z-0">
      {/* Fireplace Image Background */}
      {!imageError ? (
        <div className="relative w-full h-full">
          {/* Main Background Image */}
          <img
            src="/assets/fireplace-background.png"
            alt="Winter Fireplace Background"
            className="absolute top-0 left-0 w-full h-full object-cover blur-sm md:blur-md scale-105"
            onError={() => setImageError(true)}
            loading="eager"
          />
          
          {/* Multiple Image Layers for Depth */}
          <div className="absolute inset-0">
            {/* Layer 1: Subtle texture overlay */}
            <img
              src="/assets/noise-texture.png"
              alt="Texture Overlay"
              className="absolute inset-0 w-full h-full object-cover opacity-5 mix-blend-overlay"
            />
            
            {/* Layer 2: Gradient overlay for warmth */}
            <div className="absolute inset-0 bg-gradient-to-br from-orange-900/10 via-transparent to-blue-900/10 mix-blend-overlay"></div>
          </div>
        </div>
      ) : (
        // Fallback Gradient Background
        <div className="absolute inset-0 bg-gradient-to-br from-deepIceBlue via-winterBlue to-blue-900 flex items-center justify-center">
          <div className="text-center text-white/50">
            <FiImage className="w-16 h-16 mx-auto mb-4" />
            <p className="text-lg">Background image failed to load</p>
            <p className="text-sm mt-2">Using gradient background instead</p>
          </div>
        </div>
      )}
      
      {/* Primary Ice Blue Overlay */}
      <div className="absolute inset-0 bg-iceBlue opacity-55 mix-blend-overlay"></div>
      
      {/* Secondary Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-deepIceBlue/30 to-deepIceBlue/50"></div>
      
      {/* Subtle Noise Texture */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22400%22 height=%22400%22 viewBox=%220 0 400 400%22%3E%3Cfilter id=%22noise%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noise)%22 opacity=%220.05%22/%3E%3C/svg%3E')] opacity-20"></div>
    </div>
  );
};

export default VideoBackground;